import type { FaireProductEntity } from "../../entity_types/product";

export const p_qaze52utf2: FaireProductEntity = {
  token: "p_qaze52utf2",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE IVORY",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/38c8bbb158fe1cf5799a72c489bcbd877d6d7cd94f458ef0cbeb2b55dacd833e.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:58.763Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
